import { useCallback } from 'react';

export const useDownloadDocs = () => {
  const downloadDocs = useCallback((url: string, name: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return { downloadDocs };
};

